<template>
  <!-- the signed-in person's role, a link to its place on the fullstack (Seán, 2026-10-27); with
       two roles, only the higher (Admin, then Editor, then Tester). The roles come from the
       server (get-roles), never from the browser's metadata -->
  <nav v-if="link" class="role-links" aria-label="Your role">
    <a
      :href="getHref(link.path)"
      :class="{active: isActive}"
      @click.prevent="goTo(link.path)">{{ link.label }}</a>
  </nav>
</template>

<script setup>
import {computed} from "vue";
import {useRoute} from "vue-router";
import {getFullstackUrl} from "@/composables/useFullstackUrl";

const props = defineProps(["roles"]);

const ROLE_LINKS = [
  {role: "isAdmin", label: "Admin", path: "/admin"},
  {role: "isEditor", label: "Editor", path: "/editor"},
  {role: "isTester", label: "Tester", path: "/tester"},
];

const getHref = (path) => `${getFullstackUrl()}${path}`;
// our own site: the same tab (CLAUDE.md § Navigation conventions)
const goTo = (path) => (window.location.href = getHref(path));

// the roles held themselves: a tester counts as an editor on the server, but isn't one here
// (fullstack roleAreas.js getOwnAreas)
const getHasRole = (role) => {
  if (role === "isEditor") return props.roles?.isEditor && !props.roles?.isTesterOnly;
  return props.roles?.[role];
};
const link = computed(() => ROLE_LINKS.find(({role}) => getHasRole(role)));
// styled as the tabs (TabNav.vue): grey, in the brand colour only when its tab is open, e.g.
// #profile&admin, for the admin tab to come (Seán, 2026-10-27); for now it leaves for the fullstack
const route = useRoute();
const isActive = computed(() => {
  const name = link.value?.label.toLowerCase();
  return route.hash.split("&").slice(1).includes(name);
});
</script>

<style scoped>
.role-links {
  font-size: 13px;
  font-weight: 700;
}
a {
  padding: 2px 0;
  color: rgba(0, 0, 0, 0.35);
  text-decoration: none;
}
a.active {
  color: var(--brand-dark-color);
}
a:hover:not(.active) {
  color: rgba(0, 0, 0, 0.7);
}
a:focus-visible {
  outline: 2px solid var(--brand-dark-color);
  outline-offset: 2px;
}
</style>
